export const minimalDTAVersion = '1.0.0'
export const minimalDTADCKSVersion = '1.0.2'

export const DCKSUninitializedError = 'DCKSUninitialized'
export const DCKSNotAvailableError = 'DCKSNotAvailable'
